// import React from 'react';
import React, { useEffect } from "react";

import {
  ProductImage,
  ProductName,
  TopPickBadge,
  ContentPaper,
  SectionTitle,
  ActionBar,
  SearchContainer,
  SearchWrapper,
  SearchIcon,
  SearchInput,
  TabContainer,
} from "../../styles/FoodPage.styles";
import CustomTable from "../../components/common/CustomTable";
import { Box } from "@mui/material";
import {
  apiURL_provider,
  defaultPageSize,
} from "../../constants";
import { useNavigate } from "react-router-dom";
import { setItemWithObject } from "../../utils/cache/LocalStorage";
import { refreshHeaderOptionToken } from "../../utils/apis/api-header-option";
import axios from "axios";
import ResponsivePagination from "../../components/pagination/ResponsivePagination";
import searchSvg from "../../assets/svgs/FoodMenu/searchIcon.svg";
import {
  EmptyState,
  EmptyStateDescription,
  EmptyStateTitle,
  TableActionButton,
} from "../../styles/BundleDeal.styled";
import { LanguageText } from "../../styles/components";
import { LoadingOverlay,LoadingSpinner,LoadingSpinnerIcon } from "../../styles/loading";


const apiBaseURL_provider = apiURL_provider;

const FoodPage: React.FC = () => {
  const [auth, setAuth] = React.useState({ id: -1 });
  const [pageNo, setPageNo] = React.useState(1);
  const [totalPageCount, setTotalPageCount] = React.useState(0);
  const [search, setSearch] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const [selectedCategory, setSelectedCategory] = React.useState<any>({
    id: "",
    name: "",
    photoName: "",
    photoPath: "",
    serviceType: null,
    totalItems: 0,
  });

  useEffect(() => {
    setSelectedCategory({
      id: "",
      name: "",
      photoName: "",
      photoPath: "",
      serviceType: null,
      totalItems: 0,
    });
  }, []);
  


  const [values, setValues] = React.useState<any>({
    display: {
      id: -1,
      totalProduct: 0,
      category: 0,
      stockCount: 0,
    },
    products: [],
  });

  const [rows, setRows] = React.useState([]);
  let navigate = useNavigate();

  const searchChanged = (e: any) => {
    setSearch(e.target.value);
  };

  const pageClicked = async (page: any) => {
    setPageNo(page);
    getDataProducts(auth.id, page);
  };

  function createData(
    id: number,
    photoPath: string,
    item: string,
    price: any,
    description: string
  ) {
    return {
      id,
      photoPath,
      item,
      price,
      description,
    };
  }

  useEffect(() => {
    const authUser = JSON.parse(localStorage.getItem("authUser") || "null");
    if (authUser) {
      setAuth(authUser);
      getDataCount(authUser.id);
      getDataProducts(authUser.id, pageNo);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setRows(rows);
  }, [rows]);

  const prepareRows = (data: any) => {
    if (data && data.length > 0) {
      let tempRows: any = rows;
      tempRows = [];
      for (let i = 0; i < data.length; i++) {
        tempRows.push(
          createData(
            data[i].id,
            data[i].photoPath,
            data[i].item,
            data[i].price,
            data[i].description
          )
        );
        if (i === data.length - 1) {
          setRows(tempRows);
          setLoading(false);
        }
      }
    } else {
      setRows(data);
      setLoading(false);
    }
  };

  const clickDetails = (row: any) => {
    setItemWithObject("clicked-item", row);
    navigate("/food/entry/" + row.id);
  };


  const keyPress = async (e: any) => {
    if (e.keyCode === 13) {
      getDataProducts(auth.id, 1, selectedCategory);
    }
  };

  

  const getDataCount = (id: any, page = 1) => {
    let headers = refreshHeaderOptionToken();
    let url = "fooddelivery/GetTotalCountsByServiceProviderId";
    let param = {
      serviceProviderId: id.toString(),
    };
    axios
      .post(`${apiBaseURL_provider}/${url}`, param, {
        headers: headers.option,
      })
      .then(({ data }) => {
        try {
          let tempDisplay = values.display;
          tempDisplay.category = data.categoryTotalCount;
          tempDisplay.totalProduct = data.productTotalCount;

          setValues({
            ...values,
            display: tempDisplay,
          });
        } catch {
          setLoading(false);
        }
      })
      .catch(function (error) {
        setLoading(false);
      });
  };

  const getDataProducts = (id: any, page = 1, category = selectedCategory) => {
    let headers = refreshHeaderOptionToken();
    let url = "fooddelivery/GetMenuByServiceProviderId";

    let param = {
      serviceProviderId: id.toString(),
      // eslint-disable-next-line eqeqeq
      categoryId: !category || category.id == -1 ? "" : category.id,
      keyword: search.trim().toLowerCase() || "",
      sortBy: {
        field: 1,
        order: 1,
      },
      pgNo: page,
      pgSize: defaultPageSize,
    };

    axios
      .post(`${apiBaseURL_provider}/${url}`, param, {
        headers: headers.option,
      })
      .then(({ data }) => {
        try {
          setValues({
            ...values,
            products: data.getMenuByServiceProviderIdList || [],
          });
          setTotalPageCount(data.retPage);
          prepareRows(data.getMenuByServiceProviderIdList);
        } catch {
          setLoading(false);
        }
      })
      .catch(function (error) {
        setLoading(false);
      });
  };


  return (
    <>
    {loading && (
            <LoadingOverlay>
              <LoadingSpinner>
                <LoadingSpinnerIcon />
              </LoadingSpinner>
            </LoadingOverlay>
          )}
          <TabContainer>

<ActionBar className="mb-16 mt-16">
  <SectionTitle><LanguageText>Food Menu List</LanguageText></SectionTitle>

  <SearchContainer>
    <SearchWrapper>
      <SearchIcon>
        <img src={searchSvg} alt="SearchIcon" />
      </SearchIcon>
      <SearchInput
        id="search"
        type="text"
        placeholder="Search food item"
        value={search}
        onChange={searchChanged}
        onKeyDown={keyPress}
      />
    </SearchWrapper>
  </SearchContainer>
</ActionBar>

{rows.length === 0 ? (
  <EmptyState>
    <EmptyStateTitle>No Food Menus yet</EmptyStateTitle>
    <EmptyStateDescription>
      Create your first food menu to increase sales
    </EmptyStateDescription>
  </EmptyState>
) : (
  <ContentPaper>
    <CustomTable
      columns={[
        {
          key: "item",
          header: "Food Menu",
          width: "30%",

          render: (_, row) => (
            <div>
              <ProductImage src={row.photoPath} alt={row.item} />
              <ProductName>{row.item}</ProductName>
              {/* {topSellingItems.some((item: any) => item.id === row.id) && (
              <TopPickBadge>Top Pick</TopPickBadge>
            )} */}

              {row.id === "4cb83e39-3adf-48db-b9ed-77ba7fe3736b" && (
                <TopPickBadge>Top Pick</TopPickBadge>
              )}
            </div>
          ),
        },
        {
          key: "description",
          header: "Description",
          width: "40%",

          render: (description) => `${description}`,
        },

        {
          key: "price",
          header: "Price (SGD)",
          width: "20%",
          render: (price) => `$${price}`,
        },
        {
          key: "actions",
          header: "",
          align: "right",
          width: '100px',

          render: (_, row) => (
            <div>
              <TableActionButton
                $variant="edit"
                onClick={(e: any) => {
                  e.stopPropagation();
                  clickDetails(row);
                }}
              >
                Edit
              </TableActionButton>
            </div>
          ),
        },
      ]}
      data={rows}
      emptyMessage="No Data found."
      onRowClick={clickDetails}
    />

    <Box mt={4} display="flex" justifyContent="center">
        <ResponsivePagination
          currentPage={pageNo}
          totalPageCount={totalPageCount}
          pageSize={defaultPageSize}
          onPageChange={(page: any) => pageClicked(page)}
        />
      </Box>
  </ContentPaper>
)}
</TabContainer>
    </>
    
  );
};

export default FoodPage;
